import { get, post } from "./api_helper"

export const getData = url => get(url)
export const postData = (url, data = {}, config = {}) => post(url, data, config)
